import {TYPE_ERROR} from '../constants';

export const encodeQueryData = (data: object | undefined) => {
  if (!data) {
    return '';
  }

  try {
    const queryStringStart = '?';

    return Object.keys(data).reduce((queryString, key, index) => {
      const paramStringStart = index ? '&' : '';
      const paramString = paramStringStart +
      `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`;
      return queryString + paramString;
    }, queryStringStart);
  } catch (e) {
    throw new TypeError(TYPE_ERROR);
  }
};
